module.exports = __webpack_public_path__ + "static/netlify-00-6945068b96d50a5f1f57a2cf37d6ac45.png";